'use es6';

import { List } from 'immutable';
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import LegalConsentOptions from 'MeetingsBase/models/LegalConsentOptions';
import LegalConsentFields from 'FormsCommonComponents/LegalConsentFields';
import LegalConsent from 'FormsCommonComponents/lib/LegalConsent';
import { KOALA } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const LegalConsentInputs = ({
  legalConsentOptions,
  legalConsentResponses,
  setGivenConsent
}) => {
  const previewModel = new LegalConsent(legalConsentOptions.convertToJSON());
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(UITile, {
      style: {
        background: KOALA
      },
      compact: true,
      children: /*#__PURE__*/_jsx(UITileSection, {
        className: "p-bottom-0",
        style: {
          wordWrap: 'break-word'
        },
        children: /*#__PURE__*/_jsx(LegalConsentFields, {
          legalConsentRecord: previewModel,
          legalConsentResponses: legalConsentResponses,
          onCommunicationCheckboxChange: setGivenConsent
        })
      })
    })
  });
};
LegalConsentInputs.propTypes = {
  legalConsentOptions: PropTypes.instanceOf(LegalConsentOptions).isRequired,
  legalConsentResponses: PropTypes.instanceOf(List),
  setGivenConsent: PropTypes.func.isRequired
};
export default LegalConsentInputs;